import { Any } from "./Any";
import { is } from "../utils/is";
import { dispatch } from "../utils/dispatch";
import { Union, caseOf } from "../utils/union-type";
import { map, fold, flatten, of } from "../dispatchers";

export const Maybe = Union("Maybe", {
  Some: [Any],
  None: []
});

Maybe.of = x => of(Maybe, x);

export const maybe = x => of(Maybe, x);

dispatch.addMethod("fold", Maybe, (self, Some, None) =>
  caseOf(self, { Some, None })
);

dispatch.addMethod("map", Maybe, (self, f) =>
  fold(self, x => Maybe.Some(f(x)), () => self)
);

dispatch.addMethod("flatten", Maybe, self =>
  fold(self, x => (is(x, Maybe) ? x : Maybe.Some(x)), () => self)
);

dispatch.addMethod("flatMap", Maybe, (self, f) => flatten(map(self, f)));

dispatch.addMethod(
  "get",
  Maybe,
  (self, fallback) =>
    fallback == null ? self : fold(self, x => x, () => fallback)
);

dispatch.addMethod(
  "of",
  Maybe,
  (_, x) => (x == null ? Maybe.None() : Maybe.Some(x))
);
